module.exports = __webpack_public_path__ + "img/accounting.016834a9.jpg";